import React from "react";
import MUIStack from "@mui/material/Stack";
import MUITypography from "@mui/material/Typography";
import * as MUIIcons from "@mui/icons-material";

/**
 * @returns {JSX.Element} The InfoItem component.
 */
export default function InfoItem({ icon, label, value, alignment }) {
  const IconComponent = icon ? MUIIcons[icon.icon] : null;

  return (
    <MUIStack
      direction="row"
      spacing={1}
      alignItems={alignment || "flex-start"}
    >
      {IconComponent && (
        <IconComponent
          sx={{
            color: icon?.color,
            fontSize: icon?.fontSize || "inhert",
          }}
        />
      )}
      <MUIStack>
        <MUITypography variant="subtitle2">{label || ""}</MUITypography>
        <MUITypography variant="body2" sx={{ minHeight: "1.5em" }}>
          {value || "None"}
        </MUITypography>
      </MUIStack>
    </MUIStack>
  );
}
